module.exports = __webpack_public_path__ + "static/media/team1.ce4c3b7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/aboutme/slider/team1.png
// module id = 540
// module chunks = 0